import { render, staticRenderFns } from "./TaskListCompleted.vue?vue&type=template&id=0527c0fc&"
import script from "./TaskListCompleted.vue?vue&type=script&lang=ts&"
export * from "./TaskListCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports